import { ClipboardEvent } from "react";

export const trimPastedText = (event: ClipboardEvent<HTMLElement>) => {
  const target = event?.target;
  if (
    !(target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement)
  ) {
    return;
  }

  if (
    target instanceof HTMLInputElement &&
    !["text", "email", "number", "password", "search"].includes(
      target.type,
    )
  ) {
    return;
  }

  const pastedText = event?.clipboardData?.getData("text")?.trim() ?? "";
  const replacesWholeValue =
    target instanceof HTMLInputElement &&
    ["email", "number"]?.includes(target.type);
  const start = replacesWholeValue
    ? 0
    : (target?.selectionStart ?? target?.value?.length);
  const end = replacesWholeValue
    ? target?.value?.length
    : (target?.selectionEnd ?? start);

  event?.preventDefault?.();

  if (replacesWholeValue) {
    Object?.getOwnPropertyDescriptor(
      HTMLInputElement?.prototype,
      "value",
    )?.set?.call(target, pastedText);
  } else {
    target?.setRangeText(pastedText, start, end, "end");
  }

  target?.dispatchEvent?.(new Event("input", { bubbles: true }));
};
